import { render, staticRenderFns } from "./VoucherInformationComponent.vue?vue&type=template&id=5a428784&scoped=true&"
import script from "./VoucherInformationComponent.vue?vue&type=script&lang=js&"
export * from "./VoucherInformationComponent.vue?vue&type=script&lang=js&"
import style0 from "./VoucherInformationComponent.vue?vue&type=style&index=0&id=5a428784&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5a428784",
  null
  
)

export default component.exports